(function (angular, app) {
   "use strict";

   app.modules.course = {
      name: "app.Course"
      , constants : {
      }
      , controllers : {
      }
      , decorators : {
      }
      , directives: {
         coursepicker : "ggCoursePickerDirective"
      }
      , filters : {
      }
      , services : {
          search : "gg_CourseSearchFactory"
      }
      , routes : {
         search : {
            path : "/course/search"
            , controller : "gg_GolfCourseSearchController"
            , controllerAs : "ggGolfCourseSearchCtrl"
            , templateUrl : "app/course/controllers/golfcoursesearch.html"
            , features : {
               showHeading : true
            }
         }
         , detail : {
            controller : "gg_GolfCourseDetailController"
            , templateUrl : "app/course/controllers/golfcoursesearch-detail.html"
         }
      }
   };
   
   angular.module(app.modules.course.name, []);

}(angular, app));
